import React from 'react';

export const I18nContext = React.createContext();
